<!-- Alert -->
<p-toast key="main"
  position="top-center"
  showTransformOptions="translateY(-100%)">
  <ng-template let-message pTemplate="message">
    <i [class]="'p-toast-message-icon' + (message.icon ? ' ' + message.icon : '') + (' fa-3x ' + FlatModels.AlertControlModels.AlertSeverityIcon[message.severity])"></i>
    <div class="p-toast-message-text">
      <div class="p-toast-summary">{{ message.summary }}</div>
      <div class="p-toast-detail" [innerHTML]="message.detail | translate"></div>
    </div>
  </ng-template>
</p-toast>

<!-- Block Ui -->
@if (historySharedFacade.blockUiType$ | async; as blockUiType) {
  <p-blockUI
    [blocked]="blockUiType !== 'none'">
    @if (blockUiType === 'saving') {
      <div class="flex flex-column align-items-center row-gap-2">
        <i [class]="FlatModels.ButtonDesignModels.ButtonDefaultIcons.SAVE_BIG + FlatModels.ButtonDesignModels.ButtonDefaultIconsStyle.SUCCESS"></i>
        <medsurf-design-content-process-spinner></medsurf-design-content-process-spinner>
      </div>
    }
    @if (['loading', 'redo', 'undo'].includes(blockUiType)) {
      <medsurf-design-content-process-spinner></medsurf-design-content-process-spinner>
    }
    @if (blockUiType === 'uploading') {
      <div class="flex flex-column align-items-center row-gap-2">
        <i class="fa fa-spinner-third fa-spin"></i>
      </div>
    }
  </p-blockUI>
}

<!-- Router Outlet -->
<router-outlet ></router-outlet>
